@if (dialogData) {
    <adapt-dialog [maxWidth]="600"
                  [expandable]="false"
                  [showHelpButton]="false">
        <h3 adapt-dialog-title
            [innerHtml]="dialogData.title"></h3>
        <div adapt-dialog-content>
            @if (dialogData.message) {
                <div [froalaView]="dialogData.message"></div>
            }
            <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
            @if (dialogData.checkboxMessage) {
                <div class="mt-3">
                    <dx-check-box [value]="checkboxConfirmation"
                                  (valueChange)="checkboxConfirmation = $any($event)"
                                  [text]="dialogData.checkboxMessage"
                                  data-test="confirm-checkbox"></dx-check-box>
                </div>
            }
        </div>
        <adapt-standard-dialog-buttons adapt-dialog-footer
									   #focus
                                       [saveButtonPreset]="dialogData.confirmButtonPreset || 'confirmationOk'"
                                       [saveText]="dialogData.confirmButtonText"
                                       [saveIsDisabled]="dialogData.checkboxRequired !== false && !checkboxConfirmation"
                                       [cancelButtonPreset]="dialogData.cancelButtonPreset"
                                       [cancelText]="dialogData.cancelButtonText"
                                       [hideCancelButton]="dialogData.hideCancelButton"
                                       (saveClick)="confirm()"
                                       (cancelClick)="cancel()"></adapt-standard-dialog-buttons>
    </adapt-dialog>
}

<ng-template #projectedContent>
    <ng-content></ng-content>
</ng-template>
